import { GeoInfoReadHttp } from "../../models/geo-info-read-http.dto";
import { GeoInfoRead } from "../../models/geo-info-read.model";

export const geoInfoReadFromGeoInfoReadHttp = (geoInfoReadHttp: GeoInfoReadHttp): GeoInfoRead => {
    return {
        departementId: geoInfoReadHttp.departement_id,
        departementLabel: geoInfoReadHttp.departement_label,
        epciId: geoInfoReadHttp.epci_id,
        epciLabel: geoInfoReadHttp.epci_label,
        cityId: geoInfoReadHttp.city_id,
        cityLabel: geoInfoReadHttp.city_label,
        districtId: geoInfoReadHttp.district_id,
        districtLabel: geoInfoReadHttp.district_label
    };
}

export const geosInfoReadFromGeoInfoReadHttp = (geosInfoReadHttp: GeoInfoReadHttp[]): GeoInfoRead[] => {
    return geosInfoReadHttp.map((geoInfoReadHttp) => geoInfoReadFromGeoInfoReadHttp(geoInfoReadHttp));
}